import Vue from 'vue'
import App from './App.vue'
import './quasar'
import './registerServiceWorker'
import axios from "axios"
import VueMeta from "vue-meta";
import Vue2TouchEvents from "vue2-touch-events";
import VueRouter from 'vue-router'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import router from './router'
import store from './store'
import VueSplash from 'vue-splash';
import VueGeolocation from 'vue-browser-geolocation';
import money from 'v-money'
import PWABadge from 'pwa-badge';
import vue_jalali_moment from "vue-jalali-moment";
import AsyncComputed from 'vue-async-computed';
import VueApexCharts from 'vue-apexcharts'
import {Icon} from 'leaflet';
import JsonCSV from 'vue-json-csv'
import {Browser} from '@capacitor/browser';
import Notify from 'quasar/src/plugins/Notify.js';
import VueQRCodeComponent from 'vue-qrcode-component'

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

axios.defaults.baseURL = store.state.baseUrl
axios.defaults.headers['X-APP-VERSION'] = store.state.appVersion
axios.defaults.timeout = 2 * 60 * 1000

Vue.prototype.$axios = axios

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(VueMeta)
Vue.use(Vue2TouchEvents)
Vue.use(VueLodash, {lodash: lodash})
Vue.use(VueSplash);
Vue.use(VueGeolocation);
Vue.use(money, {precision: 0})
Vue.use(vue_jalali_moment);
Vue.use(AsyncComputed)
Vue.use(VueApexCharts)

window.Apex.chart = {fontFamily: "IRANSans,  sans-serif"};

Vue.prototype.$axios = axios

Vue.component('apexchart', VueApexCharts)
Vue.component('downloadCsv', JsonCSV)
Vue.component('qr-code', VueQRCodeComponent)

Vue.filter('toCurrency', function (value) {
    let dec = 0
    if (value === null || value === undefined || value === '') {
        return 0
    }
    value = value.toString().replaceAll(',', '');
    return '' + parseInt(value).toFixed(dec).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
});

Vue.filter('toOnlyNumeric', function (value) {
    if (value === null || value === undefined || value === '') {
        return ''
    }
    return value.replace(/[^\d]/g, '');
});

Vue.filter('toJalaliDateTime', function (value) {
    if (value === null || value === undefined || value === '') {
        return ''
    }
    const moment = require('jalali-moment')
    moment.suppressDeprecationWarnings = true;
    try {
        return `${moment(new Date(value)).locale('fa').format('YYYY/MM/DD HH:mm:ss')}`;
    } catch {
        return value
    }
});

Vue.filter('toGregorianDateTime', function (value) {
    if (value === null || value === undefined || value === '') {
        return ''
    }
    const moment = require('jalali-moment')
    try {
        return moment(value)
            .locale('en')
    } catch {
        return value
    }
});

Vue.filter('secondToTime', function (value) {
    if (value === null || value === undefined || value === '') {
        return '';
    }
    let t = new Date(1970, 0, 1);
    t.setSeconds(value);
    let s = t.toTimeString().substr(0, 8);
    if (value > 86399)
        s = Math.floor((t - Date.parse("1/1/70")) / 3600000) + s.substr(2);
    return s;
});

Vue.filter('toLoalString', function (value) {
    if (value === null || value === undefined || value === '') {
        return 0;
    }
    return value.toLocaleString();
});

Vue.filter('changeDateFormat', function (value) {
    if (value === null || value === undefined || value === '') {
        return '';
    }
    let moment = require('jalali-moment');
    let MomentDate = moment(value, 'YYYYMMDD');
    return MomentDate.format('YYYY/MM/DD');
})

Vue.mixin({
    methods: {
        async openURL(url) {
            await Browser.open({url: url});
        },
        toEnDigit(s) {
            return s.replace(/[\u0660-\u0669\u06f0-\u06f9]/g,    // Detect all Persian/Arabic Digit in range of their Unicode with a global RegEx character set
                function (a) {
                    return a.charCodeAt(0) & 0xf
                }     // Remove the Unicode base(2) range that not match
            )
        },
        getStaticImage(image) {
            if (image !== "")
                return require(`./assets/${image}`);
            else {
                return "";
            }
        },
        CurrencyShow(value) {
            let dec = 0
            if (value === null || value === undefined) {
                return 0
            }
            return '' + value.toFixed(dec).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
        },
        OnlyNumeric(value) {
            if (value === null || value === undefined || value === '') {
                return ''
            }
            return value.replace(/[^\d]/g, '');
        },
        ToJalaliDateTime(value) {
            if (value === null || value === undefined || value === '') {
                return ''
            }
            const moment = require('jalali-moment')
            moment.suppressDeprecationWarnings = true;
            try {
                return `${moment(new Date(value)).locale('fa').format('YYYY/MM/DD HH:mm:ss')}`;
            } catch {
                return value
            }
        },
        ToJalaliDateTimeGetDay(value) {
            if (value === null || value === undefined || value === '') {
                return '';
            }
            let moment = require('jalali-moment');
            let MomentDate = moment(value);
            return MomentDate.locale('fa').format('jD');
        },
        changeDateFormat(value) {
            if (value === null || value === undefined || value === '') {
                return '';
            }
            let moment = require('moment-jalali');
            let MomentDate = moment(value, 'YYYYMMDD');
            return MomentDate.format('YYYY/MM/DD');
        },
        ToJalaliDate(value) {
            if (value === null || value === undefined || value === '') {
                return '';
            }
            let moment = require('jalali-moment');
            let MomentDate = moment(value, 'YYYY/MM/DD HH:mm:ss');
            return MomentDate.locale('fa').format('YYYY/MM/DD');
        },
        numberOfMonthDays() {
            let moment = require('jalali-moment');
            let MomentDate = moment();
            return parseInt(MomentDate.locale('fa').format('DD'))
        },
        ToGregorianDateTime(value) {
            if (value === null || value === undefined || value === '') {
                return '';
            }
            let moment = require('jalali-moment');
            return moment.from(value, 'fa', 'YYYY-MM-DD').format('YYYY-MM-DD');

        },
        ToGregorianDateTimeFormat(value) {
            if (value === null || value === undefined || value === '') {
                return '';
            }
            let moment = require('jalali-moment');
            return moment.from(value, 'fa', 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

        },
        ToGregorianDateTimeFull(value) {
            if (value === null || value === undefined || value === '') {
                return '';
            }
            let moment = require('jalali-moment');
            return moment.from(value, 'fa', 'YYYY-MM-DD HH:mm:ss').toDate();

        },
        ToJalaliDateTimeByDayDiff(value, diff) {
            let moment = require('jalali-moment');
            if (value === null || value === undefined || value === '') {
                return '';
            }
            let MomentDate = moment(value, 'YYYY/MM/DD HH:mm:ss');
            return MomentDate.subtract(diff, 'days').locale('fa').format('YYYY/MM/DD HH:mm:ss');
        },
        ToJalaliDateByDayAdd(value, duration) {
            let moment = require('jalali-moment');
            if (value === null || value === undefined || value === '') {
                return '';
            }
            let MomentDate = moment.from(value, 'fa', 'YYYY/MM/DD');
            return MomentDate.add(duration, 'days').locale('fa').format('YYYY/MM/DD');
        },
        DiffToJalaliDate(start, end) {
            let moment = require('jalali-moment');
            if ((start === null || start === undefined || start === '') || (end === null || end === undefined || end === '')) {
                return '';
            }
            let MomentStartDate = moment.from(start, 'fa', 'YYYY/MM/DD');
            let MomentEndDate = moment.from(end, 'fa', 'YYYY/MM/DD');
            return moment.duration(MomentEndDate.diff(MomentStartDate)).asDays()
        },
        getTodayDateTime() {
            let moment = require('moment');
            return moment().format('YYYY-MM-DD HH:MM:ss');
        },
        getTodayDateJalali() {
            let moment = require('moment-jalali');
            return moment().format('jYYYY/jMM/jDD');
        },
        getTodayDateJalaliFull() {
            let moment = require('moment-jalali');
            return moment().format('jYYYY/jMM/jDD HH:MM:ss');
        },
        getTodayDateJalaliInt() {
            let moment = require('moment-jalali');
            return moment().format('jYYYYjMMjDD');
        },
        getTodayDateTimeByDiff(diff) {
            let moment = require('moment');
            return moment().subtract(diff, 'days').format('YYYY-MM-DD');
        },
        getDateTimeDiff(date1, date2) {
            let moment = require('moment');
            let momentData = moment(date1)
            return moment.duration(momentData.diff(moment(date2))).asSeconds()
        },
        getDateTimeDiffAsDay(date1, date2) {
            let moment = require('moment');
            let momentData = moment(date1)
            return moment.duration(momentData.diff(moment(date2))).asDays()
        },
        convertSecondToTime(value) {
            if (value === null || value === undefined || value === '') {
                return '';
            }
            let t = new Date(1970, 0, 1);
            t.setSeconds(value);
            let s = t.toTimeString().substr(0, 8);
            if (value > 86399)
                s = Math.floor((t - Date.parse("1/1/70")) / 3600000) + s.substr(2);
            return s;
        },
    }
});
new Vue({
    router,
    store,
    beforeCreate() {
        this.$axios.interceptors.request.use(config => {
            if (!navigator.onLine) return;
            return config;
        }, function (error) {
            console.log(error);
        });

        this.$axios.interceptors.response.use(config => {
            return config;
        }, async function (error) {
            if (error.response.status === 401) {
                store.state.isLogged = false;
                localStorage.clear();
                await router.push("/login").catch(() => {
                });
            } else if (error.response.status === 422) {
                store.state.isLogged = false;
                localStorage.clear();
                await router.push("/login").catch(() => {
                });
            } else if (error.response.status === 400) {
                if ('message' in error.response.data) {
                    Notify.create({
                        message: error.response.data.message,
                        color: 'negative',
                        position: 'center',
                        type: "negative"
                    })
                }
            }

            if (Promise) {
                return Promise.reject(error);
            }
        });
    },
    created() {
        const badge = new PWABadge();
        if (badge.isSupported()) {
            badge
                .asyncSetBadge(1)
                .then(() => {
                    // Badge count has shown as well
                })
                .catch((e) => {
                    console.log(e);
                });
        } else {
            badge.syncClearBadge();
        }
    },
    render: h => h(App)
}).$mount('#app')